import React from "react";
import Card from "../../../components/common/card/card";
import Button from "../../../components/common/button/button";
import { IIconBasicProps } from "../../../assets/Icons/IIconBasicProps";
import { Condition } from "../ez-quote.types";
import { useTranslation } from "../../../contexts/TranslationContext";

interface ConditionsStepProps {
  conditions: Condition[];
  selectedCondition: string | null;
  handleConditionSelect: (conditionId: string) => void;
  handleContinue: () => void;
  getIconComponent: (name: string | null) => React.FC<IIconBasicProps>;
}

const ConditionsStep: React.FC<ConditionsStepProps> = ({
  conditions,
  selectedCondition,
  handleConditionSelect,
  handleContinue,
  getIconComponent,
}) => {
  const t = useTranslation();
  return (
    <div className="conditions-container">
      {conditions.map((condition) => (
        <Card
          key={condition.id}
          title={condition.title}
          description={condition.description}
          Icon={getIconComponent(condition.icon_name)}
          iconWidth={100}
          iconHeight={100}
          onClick={() => handleConditionSelect(condition.id)}
          className={`condition-card ${
            selectedCondition === condition.id ? "selected" : ""
          }`}
        />
      ))}
      <div className="continue-button-container">
        <Button
          label={t.shared.continue}
          onClick={handleContinue}
          styleType="primary"
          disabled={!selectedCondition}
        />
      </div>
    </div>
  );
};

export default ConditionsStep;
